import React, { createContext, useState } from 'react';

// Create a new context for the selected ID
export const SelectedIDContext = createContext();

// Create a provider component
export const SelectedIDProvider = ({ children }) => {
  const [selectedId, setSelectedId] = useState(null);  // State to hold the selected ID

  // Function to update the selected ID
  const updateSelectedId = (id) => {
    setSelectedId(id);
  };

  return (
    <SelectedIDContext.Provider value={{ selectedId, updateSelectedId }}>
      {children}
    </SelectedIDContext.Provider>
  );
};
